var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MONITOR",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-MONITOR-ACTIVIDAD",
    transform: "translate(-22.000000, -19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(22.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#EA064C",
    points: "0 4.38228488 14.615552 19 19 14.6135202 4.38491421 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#EA064C",
    points: "0 24.6153488 4.38491421 29 19 14.3835637 14.615552 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#19171C",
    points: "17 21.2350293 24.7642292 29 29 24.7646706 29 24.7643704 21.2353206 17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#19171C",
    points: "17 7.68005512 21.3208267 12 29 4.31856691 29 4.3184138 24.6791733 0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHeaderLogo);
export default __webpack_public_path__ + "static/media/ico_header_logo.c56a07d581f4f938abd400a4264e50bd.svg";
export { ForwardRef as ReactComponent };